import React, { useContext, useEffect } from 'react';
import { Box, Card, Button } from 'vindi-ds-components';
import Header from './header';
import Total from './total';
import Field from './field';
import useTotal from './use_total';
import usePriceField from './use_price_field';
import { ProductContext } from '../../contexts/product_context';

function PriceSimulator() {
  const {
    price, recurrence, setPrice, setRecurrence,
  } = usePriceField();
  const { total, setTotal } = useTotal({ price, recurrence });
  const { value } = useContext(ProductContext);

  useEffect(() => {
    setTotal(0);
  }, [price, recurrence, value]);

  useEffect(() => {
    setRecurrence('');
    setPrice('');
  }, [value]);

  return (
    <Box>
      <Card boxShadow='level1' width='16em' padding='xs' minHeight='13.75em'>
        <Header />
        <RenderSimulatorInputs value={value} setPrice={setPrice} setRecurrence={setRecurrence} />
        <SimulatorButton setTotal={setTotal} price={price} recurrence={recurrence} />
        { total > 0 && <Total value={total} /> }
      </Card>
    </Box>
  );
}

const RenderSimulatorInputs = ({ setPrice, setRecurrence, value }) => (
  <Box display='flex' justifyContent='space-between' marginBottom='1em' css={{ gap: '0.5em' }}>
    <Field title='Preço' handleChange={setPrice} />
    { value === 'recurrent' && <Field title='Recorrência' handleChange={setRecurrence} /> }
  </Box>
);

const SimulatorButton = ({ setTotal, price, recurrence }) => (
  <Button
    style={{ margin: '0', width: '100%' }}
    type='button'
    variant='secondary'
    size='small'
    onClick={() => {
      const totalPrice = price * recurrence;
      setTotal(totalPrice);
    }}
  >Simular
  </Button>
);

export default PriceSimulator;
